import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "iban_format",
	standalone: false
})
export class IbanFormatPipe implements PipeTransform {
	public transform(value: string): string {
		const length: number = Math.floor(value.length / 4);
		let unformattedValue: string = value;
		let iban: string = "";

		for (let i = 0; i <= length; i++) {
			iban = iban + unformattedValue.substr(0, 4) + " ";
			unformattedValue = unformattedValue.substr(4, unformattedValue.length);
		}
		return iban.trim();
	}
}
